import type AggregationFilter from '../store/AggregationFilter';
import HouseSearchFilters from '../store/HouseSearchFilters';
import GTM from '../../../gtm/GTM';
import GTMOverviewFilterAddModel from '../../../gtm/models/GTMOverviewFilterAddModel';
import GTMOverviewFilterRemoveModel from '../../../gtm/models/GTMOverviewFilterRemoveModel';

interface AggregationComponentBindingInterface {
    aggregations: SearchResponseAggregation[];
    selectedFilters: string;
}

interface AggregationComponentContextInterface extends ContextInterface {
    element: HTMLElement;
    bindings: AggregationComponentBindingInterface;
}

export default class AggregationComponent {
    static readonly SINGLE_SELECT_AGGREGATIONS = ['houseRating', 'natureRating'];

    context: AggregationComponentContextInterface;

    static getClassName(): string {
        return 'AggregationComponent';
    }

    constructor(context: AggregationComponentContextInterface) {
        this.context = context;
        this.context.bindings.aggregations = [];
    }

    public onInit(): void {
        this.setEventListeners();
    }

    private setEventListeners(): void {
        const checkboxes: HTMLInputElement[] = Array.from(
            this.context.element.querySelectorAll('input')
        );

        const filters = HouseSearchFilters.getInstance();
        checkboxes.forEach((input) => {
            input.addEventListener('change', async () => {
                const filter = filters.get(input.name) as AggregationFilter;
                const isSingleSelect = AggregationComponent.SINGLE_SELECT_AGGREGATIONS.includes(
                    input.name
                );

                if (!input.checked) {
                    filter.remove(input.value);
                    this.#trackFilterRemove(input);
                    return;
                }

                if (isSingleSelect) {
                    filter.clear();

                    if (input.value === '') {
                        this.#trackFilterRemove(input);
                        return;
                    }
                }

                filter.add(input.value);
                this.#trackFilterAdd(input);
            });
        });
    }

    #trackFilterAdd(input: HTMLInputElement): void {
        GTM.track(
            GTMOverviewFilterAddModel.parseToGTMData({
                label: input.value,
                category: input.name
            })
        );
    }

    #trackFilterRemove(input: HTMLInputElement): void {
        GTM.track(
            GTMOverviewFilterRemoveModel.parseToGTMData({
                label: input.value,
                category: input.name
            })
        );
    }
}
